import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function PasoorRoomPage() {
  const { roomCode } = useParams();
  const navigate = useNavigate();

  const [gameType, setGameType] = useState(null); // "hokm" یا "chaharbar"

  const handleGameTypeSelect = (type) => {
    setGameType(type);
  };

  const handlePlayerCountSelect = (count) => {
    navigate(`/pasoor/game/${gameType}/${count}?room=${roomCode}`);
  };

  return (
    <div style={styles.container}>
      <h2>🎴 انتخاب نوع بازی پاسور</h2>

      {!gameType ? (
        <>
          <h3>نوع بازی را انتخاب کنید:</h3>
          <div style={styles.buttonGroup}>
            <button onClick={() => handleGameTypeSelect("hokm")} style={styles.button}>
              ♠️ حکم
            </button>
            <button onClick={() => handleGameTypeSelect("chaharbar")} style={styles.button}>
              🃏 چهار برگ
            </button>
          </div>
        </>
      ) : (
        <>
          <h3>تعداد بازیکنان را انتخاب کنید:</h3>
          <div style={styles.buttonGroup}>
            <button onClick={() => handlePlayerCountSelect(2)} style={styles.button}>
              👥 دو نفره
            </button>
            <button onClick={() => handlePlayerCountSelect(4)} style={styles.button}>
              👨‍👩‍👧‍👦 چهار نفره
            </button>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "40px",
    textAlign: "center",
    fontFamily: "sans-serif",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginTop: "30px",
    flexWrap: "wrap",
  },
  button: {
    padding: "15px 30px",
    fontSize: "18px",
    cursor: "pointer",
    borderRadius: "8px",
    border: "1px solid #888",
    backgroundColor: "#f4f4f4",
    transition: "0.3s",
  },
};
